import React from "react";
import "./styles.scss";

const Divider = () => {
  return <div className="divider"></div>;
};

export default Divider;
